import React, { useCallback, useState, useEffect } from "react";
// import Fuse from "fuse.js";
// import { CSVLink } from "react-csv";
import DataTable from "../../ComponentsFC/DataTable";
import UI from "../../shared/Components/UI/js";
import moment from "moment";
import styled from "styled-components";
import { Row, Col, Button,
  //  DatePicker,
    Input, Select, Typography } from "antd";
import DropdownIcon from "../../icons/Dropdown";
import SearchIcon from "../../icons/Search";
import ServicePatientsApi from "../../api_services/patients";

const AdminPatientAccountsTable = ({ _this }) => {
  const [tableData, setTableData] = useState([]);
  const [searchResults, setSearchResults] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [totalRecords, setTotalRecords] = useState(0);
  const [tableEntries, setTableEntries] = useState(30);
  const [currentPageNum, setCurrentPageNum] = useState(1);
  const [filterByGender, setFilterByGender] = useState("");
  const [sortByDate, setSortByDate] = useState("-createdAt");
  const [sortByName, setSortByName] = useState("");

  const getPatients = useCallback(async () => {
    try {
      setIsLoading(true);

      let params = {};

      if (filterByGender !== "") {
        params.gender = filterByGender;
      }

      if (sortByDate !== "") {
        params.sort = (sortByDate === "asc") ? "createdAt" : "-createdAt";
      }
     
      if(sortByName !== "") {
        params.sort = (sortByName === "asc") ? "patientName" : "-patientName";
      }

      if (searchQuery) {
        params.fullname = searchQuery;
      }

      if (currentPageNum) {
        params.page = currentPageNum;
        params.limit = tableEntries;
      }

      ServicePatientsApi.getPatients(params).then( res => {
        setIsLoading(false);
        if (res.status === 200) {
          let data = res.data;
          console.log(data);
          setTotalRecords(res.results.total);
          setTableData(data);
        }
      });
      
      // UI.webRequest({
      //   method: "get",
      //   url: "admin/patients",
      //   params: {
      //     ...params,
      //     page: currentPageNum,
      //     limit: tableEntries,
      //   },
      //   onFail: async (err) => {},
      //   onSuccess: async (response) => {
      //     const data = response.data.d;

      //     setTotalRecords(data.results.total);
      //     setTableData(data.data);
      //   },
      //   onFinish: () => {
      //     setIsLoading(false);
      //   },
      // });
    } catch (err) {
      // Handle Errors Here
      console.error(err);
      if (err.response) {
        let statusCode = err.response.data.statusCode;
        let errorMsg = err.response.data.message;
        if (statusCode === 404) console.log(`Error: ${statusCode} ${errorMsg}`);
        if (statusCode === 500) console.log(`Error: ${statusCode} ${errorMsg}`);
      }
    }
  }, [currentPageNum, tableEntries, filterByGender, sortByDate, sortByName, searchQuery]);

  useEffect(() => {
    getPatients();
  }, [getPatients]);

  const handlePaginateTable = (pageNum) => {
    // console.log("Currently Selected Page # of Antd Table: ", pageNum);
    setCurrentPageNum(pageNum);
  };

  const tableColumnHeader = [
    {
      title: "Patient                                            Name", // HACK 2 para mag wrap kahit maiikis word haha
      dataIndex: "name",
      key: "name",
      // render: (name) => UI.DataHelper.carespan.get_name(name) ?? " ",
      render: (key, item) => UI.get_fullname(item.firstName, item.middleName, item.lastName) ?? " ",
      width: 200,
    },
    {
      title: "User Account Name",
      dataIndex: "user",
      key: "userName",
      render: (key, item) => UI.get_fullname(item.firstName, "", item.lastName) ?? " ",
      width: 200,
    },
    {
      title: "Relationship to Patient",
      dataIndex: "relationshipToUser",
      key: "relationshipToUser",
      render: () => "Myself",
      width: 200,
    },
    {
      title: "Email                                           Address", // HACK 2 para mag wrap kahit maiikis word haha
      dataIndex: "email",
      key: "email",
      render: (email) => email ?? "",
      width: 300,
    },
    {
      title: "Mobile            Number", // HACK 2 para mag wrap kahit maiikis word haha
      dataIndex: "user",
      key: "mobileNUmber",
      render: (key, item) => (item?.phoneNumber ?? "") || (item?.phone ?? ""),
      width: 200,
    },
    {
      title: "Patient Gender",
      dataIndex: "gender",
      key: "gender",
      width: 200,
      render: (gender = "") => gender === 0 ? "Female" : "Male",
    },
    {
      title: "Registration Date",
      dataIndex: "createdAt",
      key: "date_added",
      render: (data) => {
        return moment(data).format("MM/DD/YYYY");
      },
      width: 200,
    },
    {
      title: "Consults Missed",
      dataIndex: "missedConsultations",
      key: "consultsMissed",
    },
    {
      title: "Consults Cancelled",
      dataIndex: "cancelledConsultations",
      key: "consultsCancelled",
    },
    {
      title: "Consults Completed",
      dataIndex: "completedConsultations",
      key: "consultsCompleted",
      render: (item) => <div className="text-left">{item}</div>,
    },
    // {
    //   title: "Action",
    //   dataIndex: "action",
    //   key: "action",
    //   fixed: "right",
    //   width: 100,
    // },
  ];

  const handleChangeNumOfEntries = (value) => {
    setTableEntries(Number(value));
  };

  const handleChangeSearchQuery = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleCSVExport = () => {
    const csv_data = tableData.map((item, index) => {
      const d = {
        "Patient Name": UI.get_fullname(item.firstName, item.middleName, item.lastName) ?? " ",
        "User Account Name":UI.get_fullname(item.firstName, "", item.lastName) ?? " ",
        "Relationship to Patient": "Myself",
        Email: item?.email ?? " ",
        "Mobile Number": item?.phoneNumber ?? " ",
        Gender: item.gender === 0 ? "Female" : "Male" ,
        "Registration Date": moment(item.createdAt).format("MM/DD/YYYY"),
        "Missed Consultations": item.missedConsultations,
        "Cancelled Consultations": item.cancelledConsultations,
        "Completed Consultations": item.completedConsultations,
      };

      return d;
    });

    UI.DownloadCSV("Patient Account " + UI.get_current_date_string(), csv_data);
  };

  const handleClearViaSelectField = (fieldName) => {
    console.log("Handle CLEAR", fieldName);
    if (fieldName === "Date Filter by") {
      setSearchResults([]);
    }
  };

  return (
    <>
      <FilterBox>
        <Title level={5}>Patient Accounts</Title>
        <Toolbar gutter={14}>
          <ToolItem span={8}>
            <StyledFieldLabel>Gender</StyledFieldLabel>
            <StyledSelect
              getPopupContainer={(trigger) => trigger.parentNode} // Avoid Select dropdown moves when scrolling
              placeholder="Select Option"
              style={{
                width: "100%",
              }}
              allowClear
              suffixIcon={<DropdownIcon />}
              onChange={(value) => setFilterByGender(value)}
              onClear={() => handleClearViaSelectField("Gender")}
            >
              <Select.Option title="Gender" value="male">
                Male
              </Select.Option>
              <Select.Option title="Gender" value="female">
                Female
              </Select.Option>
            </StyledSelect>
          </ToolItem>
          <ToolItem span={8}>
            <StyledFieldLabel>Registration Date</StyledFieldLabel>
            <StyledSelect
              getPopupContainer={(trigger) => trigger.parentNode} // Avoid Select dropdown moves when scrolling
              placeholder="Select Option"
              style={{
                width: "100%",
              }}
              allowClear
              suffixIcon={<DropdownIcon />}
              onChange={(value) => {
                setSortByName("")
                setSortByDate(value);
              }}
              onClear={() => handleClearViaSelectField("Registration Date")}
            >
              <Select.Option title="Registration Date" value="desc">
                Descending
              </Select.Option>
              <Select.Option title="Registration Date" value="asc">
                Ascending
              </Select.Option>
            </StyledSelect>
          </ToolItem>
          <ToolItem span={8}>
            <StyledFieldLabel>Patient Name</StyledFieldLabel>
            <StyledSelect
              getPopupContainer={(trigger) => trigger.parentNode} // Avoid Select dropdown moves when scrolling
              placeholder="Select Option"
              style={{
                width: "100%",
              }}
              allowClear
              suffixIcon={<DropdownIcon />}
              onChange={(value) => {
                setSortByDate("")
                setSortByName(value);
              }}
              onClear={() => handleClearViaSelectField("Patient Name")}
            >
              <Select.Option title="Patient Name" value="desc">
                Descending
              </Select.Option>
              <Select.Option title="Patient Name" value="asc">
                Ascending
              </Select.Option>
            </StyledSelect>
          </ToolItem>
        </Toolbar>
      </FilterBox>
      <TableBox>
        <Toolbar>
          <FieldLabel>Only Show</FieldLabel>
          <StyledSelect
            getPopupContainer={(trigger) => trigger.parentNode} // Avoid Select dropdown moves when scrolling
            defaultValue="30"
            style={{
              width: 160,
            }}
            suffixIcon={<DropdownIcon />}
            onChange={handleChangeNumOfEntries}
          >
            <Select.Option value="30">30 Entries</Select.Option>
            <Select.Option value="100">100 Entries</Select.Option>
            <Select.Option value={totalRecords}>All Entries</Select.Option>
          </StyledSelect>
          <StyledSearch
            placeholder="Enter Keyword"
            allowClear
            suffix={<SearchIcon />}
            value={searchQuery}
            onChange={(e) => {
              handleChangeSearchQuery(e);
            }}
            onPressEnter={getPatients}
            style={{ width: 200 }}
          />
          <StyledButton type="primary" onClick={handleCSVExport}>
            Export to CSV
          </StyledButton>
        </Toolbar>
        <DataTable
          tableColumnHeader={tableColumnHeader}
          dataSource={searchResults.length > 0 ? searchResults : tableData}
          defaultPageSize={30}
          pageSizeOptions={["30", "100", totalRecords]}
          tableEntries={tableEntries}
          isBackendPaginated={true}
          totalRecords={totalRecords}
          onPaginate={handlePaginateTable}
          loading={isLoading}
          scroll={{
            x: 600,
          }}
        />
      </TableBox>
    </>
  );
};

export default AdminPatientAccountsTable;

// CSS Styled Components ----------------------
const FilterBox = styled(Row)`
  position: relative;
  display: flex;
  flex-direction: column;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 10px #bfbfbf29;
  border-radius: 12px;
  padding: 33px 0 0 0;
  margin-bottom: 30px;
`;

const TableBox = styled(Row)`
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 33px 0 33px 0;
  border-radius: 12px;
  box-shadow: 0px 3px 10px #bfbfbf29;
  background: #ffffff 0% 0% no-repeat padding-box;
  font-family: Poppins;
  width: 60vw;
  min-width: 100%;
`;

const Toolbar = styled(Row)`
  display: flex;
  align-items: center;
  padding-left: 35px;
  padding-right: 35px;
  padding-bottom: 33px;
  font-family: Poppins;
  font-weight: 500; //medium
  font-size: 0.9375rem; // 15px
  line-height: 1.4375rem; // 23px
  letter-spacing: 0;
`;

const FieldLabel = styled(Typography.Paragraph)`
  color: #2e2e2e;
  margin-right: 30px;
  margin-bottom: 0 !important;
`;

const ToolItem = styled(Col)`
  position: relative;
  .ant-picker {
    margin-left: 102px;
  }
  .ant-picker-range {
    margin-left: 62px;
  }
`;

const Title = styled(Typography.Title)`
  font-family: Poppins;
  font-weight: 500 !important; //medium
  font-size: 1.4375rem !important; // 15px
  line-height: 1.4375rem !important; // 23px
  letter-spacing: 0 !important;
  color: #004f99 !important;
  padding-left: 35px;
  margin-bottom: 25px !important;
`;

const StyledFieldLabel = styled(Typography.Paragraph)`
  color: #65d1ff;
  margin-bottom: 10px !important;
`;

const StyledSelect = styled(Select)`
  .ant-select-selector {
    border-radius: 12px !important;
    border-width: 2px !important;
    height: 50px !important;
    align-items: center;
    font-size: 0.9375rem; // 15px
    line-height: 1.4375rem; // 23px
    & .ant-select-selection-placeholder {
      color: #2e2e2e;
    }
    // Options
    & .ant-select-selection-item {
      z-index: 1;
    }
  }

  // The Wrapper of Icon
  .ant-select-arrow {
    margin-right: 10px;
    top: 47% !important;
  }
  // The Wrapper of Icon for clear btn, when there's a value
  .ant-select-clear {
    top: 45%;
    right: 45px;
    opacity: 1 !important;
  }
`;

const StyledButton = styled(Button)`
  height: 50px;
  border-radius: 12px;
  border: none;
  background-color: #0e4d94;
  font-family: Poppins;
  font-weight: 500;
  font-size: 0.9375rem; // 15px
  line-height: 1.4375rem; // 23px
  margin-left: 20px;
  padding-left: 20px;
  padding-right: 20px;
  &:hover {
    background-color: #43c8ff;
  }
`;

const StyledSearch = styled(Input)`
  border-radius: 12px !important;
  border-width: 2px !important;
  height: 50px;
  width: 220px !important;
  margin-left: auto;
  .ant-input {
    font-family: Poppins;
    font-weight: 500;
    font-size: 0.9375rem; // 15px
    line-height: 1.4375rem; // 23px
  }
`;
